/**
 * Transition Tokens
 * Centralized animation timing for consistent motion across the UI
 */

export const TRANSITIONS = {
  // Duration only
  fast: "duration-150",
  default: "duration-200",
  slow: "duration-300",
  slower: "duration-500",
  
  // Combined transitions
  colors: "transition-colors duration-200",
  opacity: "transition-opacity duration-200",
  transform: "transition-transform duration-200",
  all: "transition-all duration-200",
  allFast: "transition-all duration-150",
  allSlow: "transition-all duration-300",
  
  // Semantic
  button: "transition-colors duration-200",
  link: "transition-colors duration-150",
  card: "transition-shadow duration-200",
  input: "transition-colors duration-200",
  modal: "transition-all duration-300",
  
  // Content reveal animation (excerpt teaser -> full publication)
  contentReveal: "transition-all duration-500 ease-in-out",
} as const;

export type TransitionToken = keyof typeof TRANSITIONS;
